'use strict'

const inRange_ = require('lodash/inRange')

const defaultDatasetConfiguration = require('dbsm-common/src/dataset-configuration/defaults')
const actionReducerCreator = require('dbsm-common/src/actionReducer')
const actionTypes = require('./actionTypes')
const rootActions = require('../dataset-controller/actions')

const initialRecordsState = {
  currentRecord: {
    index: undefined,
    data: undefined,
    fieldsToUpdate: undefined,
    updateSource: undefined
  },
  desiredIndex: undefined,
  refreshCurrentRecord: false,
  refreshCurrentView: false,
  defaultRecord: undefined,
  page: {
    numPagesToShow: 1,
    offset: 0,
    size: defaultDatasetConfiguration.pageSize
  },
  schema: undefined
}
const getDefaultDraft = state => Object.assign({}, state.defaultRecord)

const isIndexInView = (index, state) =>
  inRange_(
    index,
    getPaginationData(state).offset,
    getPaginationData(state).offset + getPaginationData(state).size
  )

const isDesiredIndexInView = state =>
  isIndexInView(selectDesiredRecordIndex(state), state)

const isCurrentIndexInView = state =>
  isIndexInView(selectCurrentRecordIndex(state), state)

module.exports = actionReducerCreator(
  initialRecordsState,
  new class {
    [actionTypes.SET_CURRENT_RECORD](state, action) {
      const { recordIndex, record } = action

      const newState = Object.assign({}, state, {
        currentRecord: { index: recordIndex, data: record },
        desiredIndex: recordIndex,
        refreshCurrentRecord: false
      })

      return isCurrentIndexInView(newState)
        ? newState
        : Object.assign({}, newState, {
            page: Object.assign({}, newState.page, {
              offset: newState.currentRecord.index,
              numPagesToShow: 1
            })
          })
    }

    [actionTypes.UPDATE_FIELDS](state, action) {
      const { fieldsToUpdate, updateSource } = action

      return Object.assign({}, state, {
        currentRecord: Object.assign({}, state.currentRecord, {
          fieldsToUpdate,
          updateSource
        })
      })
    }

    [actionTypes.GO_TO_INDEX](state, action) {
      const newState = Object.assign({}, state, {
        desiredIndex: action.index,
        refreshCurrentRecord: true
      })

      return isDesiredIndexInView(newState) || action.suppressRefreshView
        ? newState
        : Object.assign({}, newState, {
            page: Object.assign({}, newState.page, {
              offset: newState.desiredIndex,
              numPagesToShow: 1
            })
          })
    }

    [actionTypes.REFRESH_CURRENT_RECORD](state, action) {
      return Object.assign({}, state, { refreshCurrentRecord: true })
    }

    [actionTypes.REFRESH_CURRENT_VIEW](state, action) {
      return Object.assign({}, state, { refreshCurrentView: true })
    }

    [actionTypes.RESET_REFRESH_CURRENT_VIEW](state, action) {
      return Object.assign({}, state, { refreshCurrentView: false })
    }

    [actionTypes.SET_DEFAULT_RECORD](state, action) {
      const { record } = action

      return Object.assign({}, state, { defaultRecord: record })
    }

    [rootActions.actionTypes.SET_CONTROLLER_CONFIG](state, action) {
      const { pageSize } = action.config
      return Object.assign({}, state, {
        page: Object.assign({}, state.page, {
          size: pageSize || state.page.size
        })
      })
    }

    [rootActions.actionTypes.SET_PAGINATION_DATA](state, action) {
      const newState = Object.assign({}, state, {
        page: Object.assign({}, state.page, action.paginationData)
      })

      return isCurrentIndexInView(newState)
        ? newState
        : Object.assign({}, newState, {
            desiredIndex: newState.page.offset,
            refreshCurrentRecord: true
          })
    }

    [actionTypes.GO_TO_NEXT_PAGE](state, action) {
      const paginationData = getPaginationData(state)
      const currentPageSize = getCurrentPageSize(state)
      const offset = paginationData.offset + currentPageSize

      const newState = Object.assign({}, state, {
        page: Object.assign({}, state.page, {
          numPagesToShow: 1,
          offset
        })
      })

      return isCurrentIndexInView(newState)
        ? newState
        : Object.assign({}, newState, {
            desiredIndex: newState.page.offset,
            refreshCurrentRecord: true
          })
    }

    [actionTypes.GO_TO_PREVIOUS_PAGE](state, action) {
      const paginationData = getPaginationData(state)
      const offset = Math.max(0, paginationData.offset - paginationData.size)

      const newState = Object.assign({}, state, {
        page: Object.assign({}, state.page, {
          numPagesToShow: 1,
          offset
        })
      })

      return isCurrentIndexInView(newState)
        ? newState
        : Object.assign({}, newState, {
            desiredIndex: newState.page.offset,
            refreshCurrentRecord: true
          })
    }

    [actionTypes.INCREMENT_NUM_PAGES_TO_SHOW](state, action) {
      return Object.assign({}, state, {
        page: Object.assign({}, state.page, {
          numPagesToShow: state.page.numPagesToShow + 1
        })
      })
    }
  }()
)

const getCurrentPageSize = state => state.page.size * state.page.numPagesToShow
const getPaginationData = state => state.page
const hasCurrentRecord = state => !!selectCurrentRecord(state)
const selectCurrentRecord = state => state.currentRecord.data
const selectCurrentRecordIndex = state => state.currentRecord.index
const selectDesiredRecordIndex = state => state.desiredIndex
const selectFieldsToUpdate = state => state.currentRecord.fieldsToUpdate
const selectRefreshCurrentRecord = state => state.refreshCurrentRecord
const selectRefreshCurrentView = state => state.refreshCurrentView
const selectUpdateSource = state => state.currentRecord.updateSource

module.exports.getCurrentPageSize = getCurrentPageSize
module.exports.getPaginationData = getPaginationData
module.exports.hasCurrentRecord = hasCurrentRecord
module.exports.selectCurrentRecord = selectCurrentRecord
module.exports.selectCurrentRecordIndex = selectCurrentRecordIndex
module.exports.selectDefaultDraft = getDefaultDraft
module.exports.selectDesiredRecordIndex = selectDesiredRecordIndex
module.exports.selectFieldsToUpdate = selectFieldsToUpdate
module.exports.selectRefreshCurrentRecord = selectRefreshCurrentRecord
module.exports.selectRefreshCurrentView = selectRefreshCurrentView
module.exports.selectUpdateSource = selectUpdateSource



// WEBPACK FOOTER //
// ./records/reducer.js